import colors from 'vuetify/lib/util/colors';
import '@/assets/css/theme.css';

/**
 * IMPOSTAZIONE TEMA: vengono utilizzate le classi di colori di vuetify:
 * vedi pagina:  https://vuetifyjs.com/en/styles/colors/#classes
 */

/**
 *  ATTENZIONE: Per poter impostare il primary text è necessario definire una classe specifica
 *  (primary-text --> vedi file theme.css sopra importato) alla quale viene impostato il colore 
 *  della variabile "primaryText" qui sotto impostato (a livello di tema)
 */


// Tema
export default {
	primary: '#1976D2',
  	secondary: '#424242',
  	accent: '#82B1FF',
  	error: '#FF5252',
  	info: '#2196F3',
  	success: '#4CAF50',
  	warning: '#FFC107',
	tertiary: "#ffffff",

	primaryText: "#1976D2",
	primaryTextOnPrimary: colors.grey.darken4,
	primaryBorder: colors.grey.darken2,

	secondaryText: "#ffffff",
	secondaryTextOnSecondary: colors.grey.darken2,
	secondaryBorder: colors.grey.darken2,

	accentText: '#EF5350',
	accentTextOnAccent: "#ffffff",
	accentBorder: '#EF5350',
	
	tertiaryText: '#424242',
	//tertiaryTextOnTertiary: colors.grey.lighten2, ANDRE
	tertiaryTextOnTertiary: colors.grey.lighten2,
	tertiaryBorder: '#000000',

	quaternary: "#004080",
	quaternaryTextOnQuaternary: "#ffffff",
	
	infoText: "#2196F3",
	infoTextOnInfo: colors.shades.white,

	successText: "#4CAF50",
	successTextOnSuccess: colors.shades.white,

	errorText: "#FF5252",
	errorTextOnError: colors.shades.white,

	hoverOnMenuColor: '#ffffff',

	defaultBg: "#ffffff",
}